export default "__VITE_PUBLIC_ASSET__5a1ac237__"